import config from 'Config/index';
import { useAppContext } from 'Context/ReactAppContext';
import { useScriptLoader } from 'Src/hooks/use-script-loader/useScriptLoader';
import { t } from 'Src/i18n';

export const useOneySimulationPopin = ({ price }) => {
  useScriptLoader(config.get('psp.oney.script_url'));
  const { country, language } = useAppContext();

  const handlePopinClick = (e) => {
    e.preventDefault();
    const options = {
      country,
      language: language.toUpperCase(),
      merchant_guid: config.get('psp.oney.merchand_id'),
      payment_amount: price,
      filter_by: 'filters',
      filters: [
        {
          payment_method: 'bnpl',
          payment_method_type: 'split',
          payment_mode: t('booking.banking.paymentSchedule.bnpl.oneyInstallmentCount'),
          is_free: 'false',
          with_down_payment: 'true',
        },
      ],
      hide_logo: true,
    };

    window.loadOneyWidget(function () {
      window.oneyMerchantApp.loadSimulationPopin({ options });
    });
  };

  return {
    handlePopinClick,
  };
};
